import { Form, Input, Typography } from "antd";
import React from "react";
import { t } from "i18next";
import { useContext } from "react";
import { StoreContext } from "../../../stores";
import { useState } from "react";
import { paymentItems } from "../../../configs/const";

function Payment(props) {
    const { form } = props;
    const { initialForm } = useContext(StoreContext);
    const [payment, setPayment] = useState(
        initialForm?.payment
            ? JSON.parse(initialForm?.payment)
            : {
                  payment_code: "",
                  payment_bank: ""
              }
    );

    return (
        <div className="payment child_groups">
            {paymentItems.map((item) => (
                <div style={{ marginBottom: 12 }} key={item.key}>
                    <Typography.Text>{t(item.label)}</Typography.Text>
                    <Input
                        onChange={(e) => {
                            setPayment(Object.assign(payment, { [item.key]: e.target.value }));
                            form.setFieldsValue({ payment: JSON.stringify(payment) });
                        }}
                        value={payment[item.key]}
                        size="large"
                    />
                </div>
            ))}
        </div>
    );
}

export default Payment;
